import axios from "axios";
import Constants from "@/services/Constants";

function createCookie(name, value, minutes) {
	let date = new Date();
	date.setTime(date.getTime() + minutes * 60 * 1000);
	let expires = "; expires=" + date.toUTCString();
	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
	name = encodeURIComponent(name) + "=";
	for (let c of document.cookie.split(';')) {
		c = c.trim();
		if (c.indexOf(name) === 0) {
			return decodeURIComponent(c.substring(name.length, c.length));
		}
	}
	return null;
}

export default {
	token: null,
	init() {
		if (readCookie("access_token")) {
			this.token = readCookie("access_token");
			return true;
		}
		return false;
	},
	async check() {
		try {
			await this.axios().get(Constants.adminBackend + "/verify");
			return true;
		} catch {
			return false;
		}
	},
	login(username, password) {
		return new Promise((resolve, reject) => {
			axios.post(Constants.backend + "/login", {
				data: {
					username,
					password
				}
			}).then((res) => {
				if (res.data.status === "success") {
					createCookie("access_token", res.data.token, 179);
					resolve();
				} else {
					reject(res.data.message);
				}
			}).catch((e) => {
				console.log(e);
				reject(e);
			});
		})
	},
	logout() {
		createCookie("access_token", "", 0);
		window.location.href = "/login";
	},
	axios() {
		let token = readCookie("access_token");
		if (token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		} else {
			alert("会话已过期，请重新登录。");
			window.location.href = "/login";
		}
		return axios;
	}
}
